import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class StoreService {
  private readonly _storeId$ = new BehaviorSubject<string | null>(null);
  readonly storeId$ = this._storeId$.asObservable();

  /** call this once you know the store number */
  setStoreId(id: string): void {
    this._storeId$.next(id);
  }
}
